export default {
    stepsSlider: {
        loop: false,
        slidesPerView: 'auto',
        watchOverflow: true
    }
};